import * as React from 'react';
import { INotificationsListProps } from './types';
import './_NotificationsList.scss';
import { NotificationListItemHOC } from '../../hocs/NotificationListItem/NotificationListItemHOC';
import { NOTIFICATIONS_LIST_LABEL_TEXT } from './constants';
import { AnalyzeRender } from '../../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`NotificationsList`) : null;

export function NotificationsList ({
    notifications,
    isPopupOpen,
    isReadonly,
}: INotificationsListProps) {
    if (!notifications.length) {
        return null
    }
    if (analyzeRender) analyzeRender.call(`NotificationsList`);
    const className = 'notifications-list';
    const classNamePopup = isPopupOpen ? className + '--popup' : '';

    return (
        <div className={`
            ${className}
            ${classNamePopup}
        `}
        >
            <span className={ 'kui-label__item' }>
                { NOTIFICATIONS_LIST_LABEL_TEXT }
            </span>
            {
                notifications.map(item => {
                    if (item) {
                        const { cardId, id } = item;
                        return (
                            <NotificationListItemHOC
                                cardId={ cardId }
                                id={ id }
                                isPopupOpen={ isPopupOpen }
                                isReadonly={ isReadonly }
                                key={ id }
                            />
                        )
                    }
                })
            }
        </div>
    )
};
